import { computed } from 'vue'

export default function usePlatform(currentUser = user) {
  const platforms = computed(() => currentUser?.platforms ?? [])

  const isPlatform = computed(() => platforms.value.length > 0)

  const isPlatformSalesman = computed(() => currentUser?.isPlatformSalesman ?? false)

  const isClient = computed(() => !isPlatformSalesman.value && conf.connect_client)

  const isCompany = computed(() => currentUser?.entity?.isCompany ?? false)

  const isPlatformClient = computed(() => currentUser?.isPlatformClient ?? false)

  const defaultPlatform = computed(() => {
    if (platforms.value.length === 0) {
      return null
    }

    for (let platform of platforms.value) {
      if (platform.id === currentUser.entity.id) {
        return platform
      }
    }

    if (platforms.value.length === 1) {
      return platforms.value[0]
    }

    return null
  })

  const defaultPlatformId = computed(() => {
    if (!!defaultPlatform.value) {
      return defaultPlatform.value.id
    }

    return null
  })

  const defaultPlatformParamId = computed(() => {
    if (defaultPlatform.value?.platformParams.length === 1) {
      return defaultPlatform.value.platformParams[0].id
    }

    return null
  })

  function getPlatformById(id) {
    for (let platform of platforms.value) {
      if (platform.id === id) {
        return platform
      }
    }

    return null
  }

  return {
    platforms,
    isPlatform,
    isPlatformSalesman,
    isClient,
    isCompany,
    isPlatformClient,
    defaultPlatform,
    defaultPlatformId,
    defaultPlatformParamId,
    getPlatformById,
  }
}
